import { BlockProps } from "./blocks/registry";
import StatsUI from "../design-system/organisms/Stats";

type StrapiMedia = {
  url?: string;
};

type StatItem = {
  id?: number | string;
  titre?: string;
  descr?: string;
  icon?: StrapiMedia;
};

type StatsData = {
  id?: number | string;
  documentId?: string;
  __component?: string;
  stats?: StatItem[];
  [key: string]: unknown;
};

type MappedStatItem = {
  id: number | string;
  title: string;
  text: string;
  iconSrc: string;
};

export function mapStatsData(strapiData: StatsData): MappedStatItem[] {
  if (!Array.isArray(strapiData.stats)) return [];

  return strapiData.stats.map((item, index) => ({
    id: item.id ?? index,
    title: item.titre || "",
    text: item.descr || "",
    iconSrc: item.icon?.url || "/fallback-icon.svg",
  }));
}

export default function Stats({ data }: BlockProps<StatsData>) {
  if (!data) return null;

  const features = mapStatsData(data);

  return (
    <section key={data.documentId}>
      <StatsUI features={features} />
    </section>
  );
}
